import { render, staticRenderFns } from "./PrintInCode.vue?vue&type=template&id=527f840c&scoped=true"
import script from "./PrintInCode.vue?vue&type=script&lang=js"
export * from "./PrintInCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f840c",
  null
  
)

export default component.exports